import { Server } from 'lucide-react';

interface ProviderAttemptsToggleProps {
  show: boolean;
  onToggle: () => void;
}

export default function ProviderAttemptsToggle({ show, onToggle }: ProviderAttemptsToggleProps) {
  return (
    <button
      type="button"
      onClick={onToggle}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded text-xs border transition-colors ${
        show
          ? 'bg-primary/15 border-primary/40 text-primary'
          : 'bg-muted/30 border-border text-muted-foreground hover:bg-muted hover:text-foreground'
      }`}
      aria-label="View provider attempts"
      aria-pressed={show}
      title="Show upstream provider attempts (submit request + callback payload)"
    >
      <Server className="h-3.5 w-3.5" />
      <span>Provider attempts</span>
    </button>
  );
}
